/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for TimesheetStatusResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetTimesheetStatusByIdResponse, GetTimesheetStatusSelectResponse, GetTimesheetStatusesResponse } from "../models";

@Injectable({ providedIn: "root" })
export class TimesheetStatusResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getTimesheetStatusById(id: Signal<number> | number, resourceOptions: HttpResourceOptions<GetTimesheetStatusByIdResponse, unknown> & { defaultValue: NoInfer<GetTimesheetStatusByIdResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTimesheetStatusByIdResponse>;
    getTimesheetStatusById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetTimesheetStatusByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTimesheetStatusByIdResponse | undefined>;
    getTimesheetStatusById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetTimesheetStatusByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTimesheetStatusByIdResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/TimesheetStatus/${typeof id === 'function' ? id() : id}`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getTimesheetStatusSelect(resourceOptions: HttpResourceOptions<GetTimesheetStatusSelectResponse, unknown> & { defaultValue: NoInfer<GetTimesheetStatusSelectResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTimesheetStatusSelectResponse>;
    getTimesheetStatusSelect(resourceOptions?: HttpResourceOptions<GetTimesheetStatusSelectResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTimesheetStatusSelectResponse | undefined>;
    getTimesheetStatusSelect(resourceOptions?: HttpResourceOptions<GetTimesheetStatusSelectResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTimesheetStatusSelectResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/TimesheetStatus/Select`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getTimesheetStatuses(resourceOptions: HttpResourceOptions<GetTimesheetStatusesResponse, unknown> & { defaultValue: NoInfer<GetTimesheetStatusesResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTimesheetStatusesResponse>;
    getTimesheetStatuses(resourceOptions?: HttpResourceOptions<GetTimesheetStatusesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTimesheetStatusesResponse | undefined>;
    getTimesheetStatuses(resourceOptions?: HttpResourceOptions<GetTimesheetStatusesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetTimesheetStatusesResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/TimesheetStatus`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
